module.exports = __webpack_public_path__ + "static/media/handschuhe_ok.9e17ae92.jpg";